import { CSSObject } from "@emotion/react";
import { constants, mediaQueryStyles } from "@newsela/angelou";

import { CONTENT_LAYOUT } from "@/view/ContentLayout/ContentLayout.style";

const { mediaQuery } = mediaQueryStyles;
const { breakpoints, colors } = constants;
const { md } = breakpoints.BreakpointNames;

export const rootCss = (
  isTeacher: boolean,
  fitContent: boolean = false,
): CSSObject => ({
  alignItems: "center",
  backgroundColor: colors.ui.white[500],
  borderRadius: "12px 12px 0 0",
  bottom: 0,
  boxShadow: "0px -3px 10px rgba(0, 0, 0, 0.25)",
  display: "flex",
  height: "100%",
  justifyContent: "space-between",
  padding: "0 40px",
  position: "absolute",
  width: "100%",

  [mediaQuery.downTo(md)]: {
    border: `1px solid ${colors.ui.neutral[100]}`,
    borderRadius: "8px 0 0 8px",
    borderRightWidth: 0,
    bottom: "initial",
    boxShadow: "none",
    height: "72px",
    marginTop: CONTENT_LAYOUT.HEADER_BOTTOM_HEIGHT.md,
    paddingLeft: "26px",
    right: 0,
    width: fitContent ? "fit-content" : isTeacher ? "260px" : "158px",
  },

  "&:hover, &:focus": {
    backgroundColor: colors.ui.white[500],
  },
});

export const iconCss = {
  transform: "rotate(180deg)",
  width: "24px",

  [mediaQuery.downTo(md)]: {
    display: "none",
  },
};
